import { SMALL, MEDIUM, LARGE, EXTRA_EXTRA_SMALL, EXTRA_SMALL } from '../../constants/sizes';
export const ICON_SIZES = {
  [EXTRA_EXTRA_SMALL]: 8,
  [EXTRA_SMALL]: 12,
  [SMALL]: 16,
  [MEDIUM]: 20,
  [LARGE]: 24
};